import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=7c45cbd5&scoped=true"
import script from "./LoginButton.vue?vue&type=script&lang=ts"
export * from "./LoginButton.vue?vue&type=script&lang=ts"
import style0 from "./LoginButton.vue?vue&type=style&index=0&id=7c45cbd5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c45cbd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c45cbd5')) {
      api.createRecord('7c45cbd5', component.options)
    } else {
      api.reload('7c45cbd5', component.options)
    }
    module.hot.accept("./LoginButton.vue?vue&type=template&id=7c45cbd5&scoped=true", function () {
      api.rerender('7c45cbd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/LoginButton.vue"
export default component.exports